import { Factory } from '../../services/Factory';

namespace app.directives.charting {

  interface IChordDiagramScope extends angular.IScope {
    data: Promise<{ groups: string[]; data: string[][]; matrix: number[][]; }>;
  }

  export class ChordDiagram implements angular.IDirective {
    public restrict: string = 'E';
    public link: (scope: IChordDiagramScope, element: angular.IAugmentedJQuery) => void;
    public template: string;
    public scope = {data: '=ngModel'};
    public require = ['ngModel'];

    constructor(responsiveDesignService: app.services.utilities.ResponsiveDesignService, rootScope: IRootScope) {
      this.template = "<div class='chord' style='text-align: center'></div>";
      this.link = (scope: IChordDiagramScope, element: angular.IAugmentedJQuery) => {
        // With replace:true gone, element is the <iio-chord-diagram> wrapper.
        // Give it the .chord class so chord.scss selectors (.chord svg, etc.) still match,
        // and set display/centering so the chart renders in-flow.
        element.addClass('chord').css({ display: 'block', textAlign: 'center' });

        let drawChart = (items: any) => {
          items = Promise.resolve(items);
          if (items) {
            items.then((data: any) => {
              if (data) {
                element.children().remove();
                let calculatedRadius = (responsiveDesignService.width * 0.9) / 2;
                let outerRadius = calculatedRadius > 450 ? 450 : calculatedRadius;
                let innerRadius = outerRadius - 130;
                let fill = d3.scaleOrdinal((d3 as any).schemeAccent);
                let svg = d3.select(element[0]).append("svg")
                  .style("width", outerRadius * 1.98)
                  .style("height", outerRadius * 1.98)
                  .style("display", "initial")
                  .attr("id", "circle")
                  .append("g")
                  .attr("transform", "translate(" + outerRadius + "," + outerRadius + ")");

                let ribbon = d3.ribbon()
                  .radius(innerRadius);

                let chord = d3.chord()
                  .padAngle(.04)
                  .sortGroups(d3.descending)
                  .sortSubgroups(d3.descending)
                  .sortChords(d3.descending)(data[0].matrix);


                let chords = svg.selectAll(".chord")
                  .data(chord)
                  .enter().append("path")
                  .attr("class", "chord")
                  .style("fill", (d, index, _) => fill(`${index}`).toString())
                  .attr("d", ribbon as any);

                let arc = d3.arc()
                  .innerRadius(innerRadius)
                  .outerRadius(innerRadius + 20);

                let g = svg.selectAll(".group")
                  .data(chord.groups)
                  .enter().append("g")
                  .attr("class", "group")
                  .on("mouseover", (d, i) => {
                    chords.classed("fade", (p: any) => {
                      return p.source.index != i
                        && p.target.index != i;
                    });
                  })
                  .on("mouseout", () => {
                    chords.classed("fade", () => {
                      return false;
                    });
                  }).on("click", (d, index) => {
                    rootScope.$broadcast("BasicSearch.Triggered", "emailFrom:\"" + data[0].groups[index] + "\" OR emailRecipients: \"" + data[0].groups[index] + "\"");
                  });

                g.append("path")
                  .style("fill", (d, index, _) => fill(`${index}`).toString())
                  .style("stroke", (d, index, _) => fill(`${index}`).toString())
                  .attr("d", arc as any);

                svg.append("g").selectAll(".arc")
                  .data(chord.groups)
                  .enter().append("svg:text")
                  .attr("dy", ".35em")
                  .attr("text-anchor", (d: any) => {
                    return ((d.startAngle + d.endAngle) / 2) > Math.PI ? "end" : null;
                  })
                  .attr("transform", (d: any) => {
                    return "rotate(" + (((d.startAngle + d.endAngle) / 2) * 180 / Math.PI - 90) + ")"
                      + "translate(" + (innerRadius + 25) + ")"
                      + (((d.startAngle + d.endAngle) / 2) > Math.PI ? "rotate(180)" : "");
                  })
                  .text((d: any) => {
                    return data[0].groups[d.index].length > 19 ? data[0].groups[d.index].substring(0, 16) + "..." : data[0].groups[d.index];
                  });

                d3.select(self.frameElement).style("height", outerRadius * 1.98 + "px");
              }
            });
          }
        };

        scope.$on('ResponsiveDesignService.WindowResized', () => {
          element.children().remove();
          drawChart(scope.data);
        });

        scope.$watch("data", drawChart);
      }
    }
  }

  frontendApp.directive("iioChordDiagram", ["ResponsiveDesignService", "$rootScope", Factory.Create(ChordDiagram)]);
}
